import DatePicker from 'react-datepicker';

export const dateFieldConfig = {
  admission_date_from: {
    maxDate: new Date(),
    resetField: 'admission_date_to',
  },

  admission_date_to: {
    dependsOn: 'admission_date_from',
    minDateField: 'admission_date_from',
    maxDate: new Date(),
  },

  discharge_date_from: {
    maxDate: new Date(),
    minDateField: 'admission_date_from',
    resetField: 'discharge_date_to',
  },

  discharge_date_to: {
    dependsOn: 'discharge_date_from',
    minDateField: 'discharge_date_from',
    maxDate: new Date(),
  },

  separation_date_from: {
    maxDate: new Date(),
    minDateField: 'admission_date_from',
    resetField: 'separation_date_to',
  },

  separation_date_to: {
    dependsOn: 'separation_date_from',
    minDateField: 'separation_date_from',
    maxDate: new Date(),
  },
  start_date: {
  maxDate: new Date(),
  resetField: 'end_date',
},

end_date: {
  dependsOn: 'start_date',
  minDateField: 'start_date',
  maxDate: new Date(),
},
};

export const formatYYYYMMDD = (d) =>
  d
    ? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
        2,
        '0',
      )}-${String(d.getDate()).padStart(2, '0')}`
    : null;

export const DatePickerWithValidation = (field, local, setLocal) => {
  if (field.type !== 'date') return null;

  const config = dateFieldConfig[field.name];

  return (
    <DatePicker
      selected={local[field.name] ? new Date(local[field.name]) : null}
      onChange={(date) => {
        const formattedDate = date ? formatYYYYMMDD(date) : null;

        setLocal((prev) => {
          const updated = {
            ...prev,
            [field.name]: formattedDate,
          };

          if (
            config?.resetField &&
            prev[config.resetField] &&
            new Date(prev[config.resetField]) < date
          ) {
            updated[config.resetField] = null;
          }

          return updated;
        });
      }}
      className="workflow-him-filter-date-picker"
      dateFormat="dd-MM-yyyy"
      placeholderText={field.label}
      isClearable
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
      maxDate={config?.maxDate || null}
      minDate={
        config?.minDateField && local[config.minDateField]
          ? new Date(local[config.minDateField])
          : null
      }
      disabled={config?.dependsOn ? !local[config.dependsOn] : false}
      onKeyDown={(e) => e.key !== 'Backspace' && e.preventDefault()}
    />
  );
};
